import { StatusBar, Style } from '@capacitor/status-bar';

export const setStatusBarDefault = async () => {
  await StatusBar.setStyle({ style: Style.Default });
  await StatusBar.hide();
};
